// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"074635eb","228":"0e86aa49","991":"3d64477f"}[chunkId] + ".chunk.js";
};